import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Typography,
  MenuItem,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Collapse,
  IconButton,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  Drawer,
  Box,
  Slide,
  Backdrop,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  Checkbox,
  Avatar,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import usePrevious from "../../../helpers/previousProps";
import { updateDepartmentDetails } from "../../../../../../containers/actions/userActions";
// import DeleteIcon from '@material-ui/icons/Delete';
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import {
  ChevronLeft,
  ChevronRight,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";

import CloseIcon from "@material-ui/icons/Close";
// import { fetchAlpatiaDefaultSettings } from '../../../../../containers/actions/ecosystemActions';
// import usePrevious from '../../../../pcmp/components/helpers/previousProps';
import { useDispatch, useSelector } from "react-redux";
// import { Autocomplete } from '@material-ui/lab';
// import { updateOrgProfile } from '../../../../../containers/actions/userActions';
// import BackDrop from '../../../../../components/pcmp/components/common/models/BackDrop';
import BackDrop from "../../models/BackDrop";
import CustomButton from "../../projectsDashboard/CusomButton";
import {
  FETCH_DEPARTMENT_DETAILS_LOADING,
  UPDATE_DEPARTMENT_DETAILS,
} from "../../../../../../containers/actions/types";
// import { fetchDepartmentDetails } from '../../../../../../containers/actions/userActions';
import { fetchUserfromDepartment } from "../../../../../../containers/actions/userActions";
import { FETCH_USERFROM_DEPT_LOADING } from "../../../../../../containers/actions/types";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#F9F9FC",
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1rem",
    backgroundColor: "#F5F9FF",
  },
  head: {
    textAlign: "center",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "12px",
    right: "10px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#FF0000",
    },
  },
  addButton: {
    border: "1px solid black",
    borderRadius: "25px",
    color: "black",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    fontSize: "14px",
    textTransform: "none",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "Black",
      color: "white",
    },
  },
  deleteButton: {
    color: theme.palette.error.main,
  },
  content: {
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    //color: '#fff',
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  inline: {
    fontSize: "1.35rem",
    display: "inline",
    fontWeight: 550,
    marginBottom: "0.5rem",
  },
  heading: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  hr: {
    border: "1px solid grey",
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
    width: "100%",
    borderBottom: "thick",
  },
  textfieldWidth: {
    width: "85%",
    marginTop: "8px",
  },
  hideDropdown: {
    "& .MuiAutocomplete-popupIndicator": {
      display: "none",
    },
    "& .MuiAutocomplete-clearIndicator": {
      display: "none",
    },
  },
  hideDeleteIcon: {
    "& .MuiChip-deleteIcon": {
      display: "none",
    },
    color: "#000000",
    border: "1px solid #000000",
    marginRight: "4px",
  },
  required: {
    color: "red",
    marginLeft: "4px",
  },
  requiredStar: {
    color: "red",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontWeight: 600,
  },
  input: {
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&[type=number]": {
      "-moz-appearance": "textfield",
    },
    overflow: "hidden",
    pointerEvents: "none",
    touchAction: "none",
    userSelect: "none",
    resize: "none",
  },
  tableContainer: {
    border: "1px solid #ddd",
    // maxWidth: 800,
    // maxWidth: "60vw",
    width: "90vw",
    margin: 0,
    marginTop: "1rem",
  },
  table: {
    // minWidth: 600,
    width: "100%",
  },
  dialogContent: {
    textAlign: "center",
    padding: "24px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "54px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  dialogPaper: {
    animation: `$slideIn 0.3s ease-out`,
  },
  "@keyframes slideIn": {
    from: {
      transform: "translateX(100%)",
    },
    to: {
      transform: "translateX(0)",
    },
  },
}));

const EditDepartmentScreen = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { openDialog, closeEditDepartments } = props;

  const [updateError, setUpdateError] = useState(false);
  const [updatedData, setUpdatedData] = useState({});
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedDepartmentID, setSelectedDepartmentID] = useState(null);
  const [markedDepartment, setMarkedDepartment] = useState(null);
  const [selectedRole, setSelectedRole] = useState("");
  const [autofillChecked, setAutofillChecked] = useState(false);
  const [userDepartmentRole, setUserDepartmentRole] = useState({});
  const [actionType, setActionType] = useState(null);
  const [firstSelectedDepartment, setFirstSelectedDepartment] = useState(null);
  const [firstSelectedRole, setFirstSelectedRole] = useState(null);

  const errRef = useRef();
  const scrollToTop = () => {
    setTimeout(
      () => errRef.current.scrollIntoView({ behavior: "smooth", block: "end" }),
      100
    );
  };

  const scrollToBottom = () => {
    setTimeout(() => {
      errRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }, 100);
  };

  const fetchDepartmentsList = useSelector((state) =>
    state?.user?.fetchUserfromDeptDetails
      ? state?.user?.fetchUserfromDeptDetails
      : "data"
  );

  const fetchDepartmentsListLoading = useSelector((state) =>
    state?.user?.fetchUserfromDeptLoading
      ? state?.user?.fetchUserfromDeptLoading
      : []
  );

  const [departmentDetailsList, setDepartmentDetailsList] = useState([]);

  const updateDepartmentsData = useSelector((state) =>
    state?.user?.updateDepartments ? state.user.updateDepartments : []
  );
  const prevUpdateDepartmentsData = usePrevious(updateDepartmentsData);

  const didMountRef = useRef(false);

  useEffect(() => {
    dispatch({
      type: FETCH_USERFROM_DEPT_LOADING,
      payload: true,
    });
    dispatch(fetchUserfromDepartment());
  }, []);

  useEffect(() => {
    if (
      fetchDepartmentsList &&
      fetchDepartmentsList?.departmentDetailsList?.length
    ) {
      const enrichedDepartments =
        fetchDepartmentsList?.departmentDetailsList?.map((department) => ({
          ...department,
          originalDepartmentName: department.departmentName,
          isNew: false, // Existing departments are not new
          isModified: false, // No modifications initially
          markForDelete: false, // Not marked for deletion initially
        }));
      setDepartmentDetailsList(enrichedDepartments);
    }
  }, [fetchDepartmentsList]);

  useEffect(() => {
    if (didMountRef.current) {
      if (
        JSON.stringify(updateDepartmentsData) !==
        JSON.stringify(prevUpdateDepartmentsData)
      ) {
        if (updateDepartmentsData.status === true) {
          // setLoading(false);
          setUpdateError(false);
          setUpdatedData(updateDepartmentsData);
          setOpenSuccessDialog(true);
          setOpenDrawer(false);
        } else if (updateDepartmentsData.status === false) {
          // setLoading(false);
          setUpdateError(true);
          scrollToTop();
          setUpdatedData(updateDepartmentsData);
          setOpenSuccessDialog(false);
        }
      }
    } else {
      didMountRef.current = true;
    }
  }, [updateDepartmentsData, prevUpdateDepartmentsData]);

  const handleDepartmentChange = (userID, departmentID) => {
    const selectedDept = fetchDepartmentsList?.departmentDetailsList.find(
      (dept) => dept.departmentID === departmentID
    );

    if (!selectedDept) return;

    setUserDepartmentRole((prevState) => {
      const updatedState = {
        ...prevState,
        [userID]: {
          ...prevState[userID],
          selectedDepartmentID: departmentID,
          markedDepartment: selectedDept,
        },
      };

      // Propagate changes if autofill is enabled and user is the first
      if (autofillChecked) {
        Object.keys(updatedState).forEach((userId) => {
          if (userId !== userID) {
            updatedState[userId] = {
              ...updatedState[userId],
              selectedDepartmentID: departmentID,
              markedDepartment: selectedDept,
            };
          }
        });
      }

      return updatedState;
    });
  };
  // const handleRoleChange = (userID, roleName) => {
  //   const selectRole = userDepartmentRole[
  //     userID
  //   ]?.markedDepartment?.rolesList?.find((role) => role.role_name === roleName);

  //   setUserDepartmentRole((prevState) => ({
  //     // const updatedState = { ...prevState };

  //     // // Assign role to the selected user
  //     // updatedState[userID] = {
  //     //   ...updatedState[userID],
  //     //   selectedRole: roleName,
  //     //   selectedRoleId: selectedRole?.collaborator_role_id || null,
  //     //   saas_user_id: userID,
  //     // };

  //     // // Auto-fill for all users in the same department if autofill is enabled
  //     // if (autofillChecked) {
  //     //   Object.keys(prevState).forEach((otherUserID) => {
  //     //     if (
  //     //       otherUserID !== userID &&
  //     //       prevState[otherUserID]?.selectedDepartmentID ===
  //     //         prevState[userID]?.selectedDepartmentID
  //     //     ) {
  //     //       updatedState[otherUserID] = {
  //     //         ...updatedState[otherUserID],
  //     //         selectedRole: roleName,
  //     //         selectedRoleId: selectedRole?.collaborator_role_id || null,
  //     //       };
  //     //     }
  //     //   });
  //     // }

  //     // return updatedState;

  //     ...prevState,
  //     [userID]: {
  //       ...prevState[userID],
  //       selectedRole: roleName,
  //       selectedRoleId: selectRole?.collaborator_role_id || null,
  //       saas_user_id: userID,
  //     },
  //   }));
  // };
  const handleRoleChange = (userID, roleName) => {
    const selectRole = userDepartmentRole[
      userID
    ]?.markedDepartment?.rolesList?.find((role) => role.role_name === roleName);

    setUserDepartmentRole((prevState) => {
      const updatedState = { ...prevState };

      // Update the role for the selected user
      updatedState[userID] = {
        ...updatedState[userID],
        selectedRole: roleName,
        selectedRoleId: selectRole?.collaborator_role_id || null,
      };

      // If autofill is checked, propagate the role to all other users
      if (autofillChecked) {
        const firstUserId = getFirstUserId();
        const firstUserRole = updatedState[firstUserId]?.selectedRole;

        Object.keys(updatedState).forEach((userId) => {
          if (userId !== userID) {
            updatedState[userId] = {
              ...updatedState[userId],
              selectedRole: firstUserRole || roleName, // Use the first user's role or the current role
            };
          }
        });
      }

      return updatedState;
    });
  };
  const UserAvatar = ({ profileImage, profileName }) => {
    return (
      <Box display="flex" alignItems="center">
        <Avatar
          src={profileImage} // Use the Base64 string here
          alt={profileName} // Optional: Alt text for accessibility
          style={{ marginRight: "8px" }} // Adjust spacing if needed
        />
      </Box>
    );
  };

  const handleAutofillChange = (event) => {
    const isChecked = event.target.checked;
    setAutofillChecked(isChecked);

    if (isChecked) {
      const firstUserId = getFirstUserId();
      if (!firstUserId) return;

      const firstUserDept =
        userDepartmentRole[firstUserId]?.selectedDepartmentID;
      const firstUserRole = userDepartmentRole[firstUserId]?.selectedRole;
      const firstUserMarkedDept =
        userDepartmentRole[firstUserId]?.markedDepartment; // Get department details

      if (!firstUserDept || !firstUserRole || !firstUserMarkedDept) {
        // alert("Please select department and role for the first user first.");
        setAutofillChecked(false);
        return;
      }

      setUserDepartmentRole((prevState) => {
        const updatedState = { ...prevState };
        Object.keys(prevState).forEach((userId) => {
          if (userId !== firstUserId) {
            updatedState[userId] = {
              ...updatedState[userId],
              selectedDepartmentID: firstUserDept,
              selectedRole: firstUserRole,
              markedDepartment: firstUserMarkedDept,
            };
          }
        });
        return updatedState;
      });
    }
  };

  const handleAddRow = () => {
    const newDepartment = {
      tempID: `temp-${Date.now()}`, // Unique identifier for new rows
      departmentName: "",
      departmentType: "New", // Default type
      departmentID: "NA",
      isNew: true,
      isModified: false,
      roles: { roleName: "NA" },
      markForDelete: false,
    };
    setDepartmentDetailsList((prevList) => [...prevList, newDepartment]);
    scrollToBottom();
  };

  const handleDepartmentNameChange = (index, value) => {
    setDepartmentDetailsList((prevList) => {
      const updatedList = [...prevList];
      const department = updatedList[index];
      const originalValue = department.originalDepartmentName || ""; // Store original value

      // Only set `isModified` if the value has actually changed
      const isModified = originalValue !== value;

      // Update the department object
      updatedList[index] = {
        ...department,
        departmentName: value,
        isModified, // Set to true if value has changed, false otherwise
      };

      return updatedList;
    });
  };

  const handleProceedDelete = (departmentID, tempID) => {
    // setSelectedDepartment(department);
    setDepartmentDetailsList((prevList) => {
      return prevList
        .map((item) => {
          // Flag new rows for deletion (based on tempID and isNew)
          if (item.tempID === tempID && item.isNew) {
            return { ...item, markForDelete: true };
          }
          // Flag existing rows for deletion (based on departmentID)
          if (item.departmentID === departmentID && !item.isNew) {
            return { ...item, markForDelete: true };
          }
          return item;
        })
        .filter((item) => {
          // Remove newly added rows marked for deletion
          // if (item.isNew && item.departmentID === "NA" && item.markForDelete) {
          //   return true;
          if (item.isNew && item.tempID === tempID && item.markForDelete) {
            return false;
          }

          // Remove existing rows marked for deletion
          if (item.departmentID === departmentID && item.markForDelete) {
            return true;
          }

          return true;
        });
    });
    setShowDrawer(false);
    setOpenDrawer(true);
  };

  // const handleDeleteRow = (department) => {
  //   setSelectedDepartment(department);
  //   setShowDrawer(true);
  // };

  const handleDeleteRow = (department, departmentID, tempID) => {
    // Check if all roles in department have no users
    const hasNoUsers = department.rolesList.every(
      (role) => role.userCount === 0
    );

    if (hasNoUsers) {
      // Prepare the payload with an empty saasUserChangesList
      setDepartmentDetailsList((prevList) => {
        return prevList
          .map((item) => {
            // Flag new rows for deletion (based on tempID and isNew)
            if (item.tempID === tempID && item.isNew) {
              return { ...item, markForDelete: true };
            }
            // Flag existing rows for deletion (based on departmentID)
            if (item.departmentID === departmentID && !item.isNew) {
              return { ...item, markForDelete: true };
            }
            return item;
          })
          .filter((item) => {
            // Remove newly added rows marked for deletion
            if (item.isNew && item.tempID === tempID && item.markForDelete) {
              return false;
            }
            return true;
          });
      });

      const updatePayload = {
        departmentDetailsList: departmentDetailsList
          .filter(
            (dept) =>
              dept.isNew ||
              dept.isModified ||
              dept.markForDelete ||
              dept.departmentID === departmentID
          )
          .map((dept) => ({
            departmentID: dept.departmentID,
            departmentName: dept.departmentName,
            departmentType: dept.departmentType,
            markForDelete:
              dept.markForDelete || dept.departmentID === departmentID, // Mark for delete
            saasUserChangesList: [], // Ensure it's an empty array
          })),
      };

      if (updatePayload.departmentDetailsList.length > 0) {
        dispatch(updateDepartmentDetails(updatePayload));
      }
    } else if (!hasNoUsers) {
      // Proceed with opening the delete confirmation drawer
      setSelectedDepartment(department);
      setShowDrawer(true);
    } else {
      // Proceed with opening the delete confirmation drawer
      setSelectedDepartment(department);
      setShowDrawer(true);
    }
  };

  const handleUpdate = (type) => {
    setActionType(type);
    setUpdateError(false);
    dispatch({
      type: UPDATE_DEPARTMENT_DETAILS,
      payload: {},
    });

    const updatePayload = {
      departmentDetailsList: departmentDetailsList
        .filter(
          (department) =>
            department.isNew ||
            department.isModified ||
            department.markForDelete
        ) // Include new, modified, or deleted rows
        .map((department) => {
          // Extract users only from the department being deleted
          const usersFromDeletedDepartment = department.rolesList.flatMap(
            (role) =>
              role.userDetails.map((user) => ({
                saas_user_id: user.saas_user_id, // Correct saas_user_id from deleted department
              }))
          );

          // Ensure users are mapped to selected department and role from dropdown
          const saasUserChangesList = usersFromDeletedDepartment.flatMap(
            (user) =>
              Object.values(userDepartmentRole).flatMap((roleInfo) =>
                roleInfo.markedDepartment.rolesList.map((role) => ({
                  saas_user_id: user.saas_user_id, // Users from deleted department
                  department_id: roleInfo.selectedDepartmentID, // Selected department from dropdown
                  collaborator_role_id: role.collaborator_role_id, // Selected role from dropdown
                }))
              )
          );

          // if (department.isNew) {
          //   return {
          //     departmentName: department.departmentName,
          //     departmentType: department.departmentType,
          //   };
          // }
          return {
            departmentID: department.departmentID,
            departmentName: department.departmentName,
            departmentType: department.departmentType,
            markForDelete: department.markForDelete || false, // Ensure markForDelete is included
            saasUserChangesList: saasUserChangesList,
          };
        }),
    };
    dispatch(updateDepartmentDetails(updatePayload));
  };

  const handleSaveChanges = () => {
    setUpdateError(false);
    dispatch({
      type: UPDATE_DEPARTMENT_DETAILS,
      payload: {},
    });

    const updatePayload = {
      departmentDetailsList: departmentDetailsList
        .filter(
          (department) =>
            department.isNew ||
            department.isModified ||
            department.markForDelete
        ) // Include new, modified, or deleted rows
        .map((department) => {
          if (department.isNew) {
            return {
              departmentName: department.departmentName,
              departmentType: department.departmentType,
            };
          }
          return {
            departmentID: department.departmentID,
            departmentName: department.departmentName,
            departmentType: department.departmentType,
            markForDelete: department.markForDelete || false, // Ensure markForDelete is included
            saasUserChangesList: [],
          };
        }),
    };

    dispatch(updateDepartmentDetails(updatePayload));
  };

  const handleCancel = () => {
    closeEditDepartments();
  };

  const handleClose = () => {
    dispatch({
      type: UPDATE_DEPARTMENT_DETAILS,
      value: {},
    });
    if (actionType === "confirm") {
      setOpenSuccessDialog(false);
      // setOpenDrawer(false);
      dispatch({
        type: FETCH_USERFROM_DEPT_LOADING,
        payload: true,
      });
      dispatch(fetchUserfromDepartment()); // Refresh user data
    } else {
      setOpenSuccessDialog(false);
      closeEditDepartments(); // Close the edit screen
    }
    setOpenSuccessDialog(false); // Close success dialog
  };

  // Check if any changes were made
  // const hasChanges = departmentDetailsList.some(department =>
  //   department.isNew || department.isModified || department.markForDelete
  // );
  const handleDisableSave = () => {
    // Check if there are any departments in the list
    if (departmentDetailsList.length === 0) return true;
    const lastDepartment =
      departmentDetailsList[departmentDetailsList.length - 1];
    // Check if the last department's name is empty
    if (lastDepartment.departmentName.trim() === "") return true;
    // Check if any changes were made
    const hasChanges = departmentDetailsList.some(
      (department) =>
        department.isNew || department.isModified || department.markForDelete
    );
    return !hasChanges;
  };
  const getFirstUserId = () => {
    const firstRole = selectedDepartment?.rolesList?.[0];
    const firstUser = firstRole?.userDetails?.[0];
    return firstUser?.saas_user_id;
  };

  // const autofillFields = () => {
  //   if (autofillChecked && selectedDepartment) {
  //     // Find the selected role within the department
  //     const selectedRoleDetails = selectedDepartment?.rolesList?.find(
  //       (role) => role.role_name === selectedRole
  //     );

  //     if (selectedRoleDetails) {
  //       // Autofill department and role
  //       setSelectedDepartmentID(selectedDepartment?.departmentID);
  //       setSelectedRole(selectedRoleDetails?.role_name);
  //     }
  //   }
  // };

  // const autofillFields = () => {
  //   if (autofillChecked && selectDepartment && selectedRole) {
  //     // Find the selected role within the department
  //     const selectedRoleDetails = selectDepartment?.rolesList?.find(
  //       (role) => role.role_name === selectedRole
  //     );
  //     if (selectedRoleDetails) {
  //       // Autofill department and role
  //       setSelectedDepartmentID(selectDepartment?.departmentID);
  //       setSelectedRole(selectedRoleDetails?.role_name);
  //     }
  //   }
  // };

  return (
    <>
      <BackDrop />
      <Dialog open={openDialog} fullScreen>
        <DialogTitle style={{ padding: "0px" }}>
          <Grid item xs={12} className={classes.header}>
            <Grid item xs={12} className={classes.titleGrid}>
              <Grid item xs={12} className={classes.head}>
                <Typography variant="h6" style={{ fontSize: "1.875rem" }}>
                  Edit Departments
                </Typography>
                <Typography>Review details of the departments</Typography>
              </Grid>
            </Grid>

            <Grid item xs={2} sm={2} md={2}>
              <Typography
                variant="body2"
                className={classes.closeBtn}
                onClick={handleCancel}
              >
                Cancel{" "}
                <CloseIcon style={{ fontSize: "35px", color: "#FF0000" }} />
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent
          style={{
            // maxWidth: "70vw",
            margin: "0 auto",
            // paddingLeft: "20rem",
            paddingTop: "32px",
            // width: "100%",
            // backgroundColor: "cyan",
          }}
        >
          {updateError === true && (
            <Grid
              ref={(el) => {
                errRef.current = el;
              }}
              style={{
                // paddingLeft: "150px",
                paddingTop: "8px",
                width: "93%",
                paddingBottom: "16px",
              }}
            >
              {/* {Object.keys(updatedData.errorDescription).map((key) => ( */}
              <Typography
                variant="h6"
                style={{
                  border: "1px solid #FF0000",
                  backgroundColor: "#FFF0F0",
                  opacity: "1",
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                {updatedData?.errorDescription
                  ? updatedData.errorDescription
                  : updatedData.errorMessage}
              </Typography>
              {/* ))}  */}
            </Grid>
          )}
          {/* <Grid xs={12} sm={6}>
            <Typography variant="body2" className={classes.heading}>
              Department details
            </Typography>
            <hr className={classes.hrLine} />
          </Grid> */}
 <Grid item xs={12}>
                            <Typography variant="body2" className={classes.inline} style={{ fontSize: "1.87rem",fontStyle: "500"}}>
                             Department details
                            </Typography>
                            <hr className={classes.hrLine} />
                          </Grid>
          <Grid
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "2rem"
              // width: "50.2rem",
              // width: "70vw",

              // backgroundColor: "red",
            }}
            xs={12}
          >
           
            <Grid>
              <Typography variant="body1" className={classes.inline}>
                List of departments{" "}
                <span className={classes.requiredStar}> *</span>
              </Typography>
            </Grid>
            <Grid>
              <Button
                className={classes.addButton}
                textColor="black"
                // Set a fixed width for all buttons
                onClick={handleAddRow}
              >
                Add new department
              </Button>
            </Grid>
          </Grid>

          <TableContainer
            style={{ maxHeight: "90%", overflow: "auto" }}
            className={classes.tableContainer}
          >
            <Table stickyHeader className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.header}>
                    Department name
                  </TableCell>
                  <TableCell className={classes.header}>
                    Department ID
                  </TableCell>
                  <TableCell className={classes.header}>
                    Department Type
                  </TableCell>
                  <TableCell className={classes.header}>
                    Role (No. of team members)
                  </TableCell>
                  <TableCell className={classes.header}>Action</TableCell>
                </TableRow>
              </TableHead>
              {fetchDepartmentsListLoading === true ? (
                <TableRow style={{ height: 150 }}>
                  <TableCell colSpan={12}>
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="primary" thickness={7} />
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                <TableBody
                  ref={(el) => {
                    errRef.current = el;
                  }}
                >
                  {/* {departmentDetailsList.map((department, index) => ( */}
                  {departmentDetailsList
                    // .filter((department) => !department.markForDelete)
                    .map((department, index) => (
                      <TableRow
                        key={index}
                        style={index % 2 ? { backgroundColor: "#F9F9FC" } : {}}
                      >
                        <TableCell>
                          {department.isNew ||
                          department.departmentType === "New" ? (
                            <TextField
                              value={department.departmentName}
                              onChange={(e) =>
                                handleDepartmentNameChange(
                                  index,
                                  e.target.value
                                )
                              } 
                              onBlur={(e) => {
                                const { value } = e.target;
                                // Trim leading and trailing spaces for string values
                                if (typeof value === "string" && value.trim() !== value) {
                                  handleDepartmentNameChange(index, value.trim());
                                }
                              }}
                              variant="outlined"
                              size="small"
                              onInput={(e) => {
                                // Allow only alphabets and prevent invalid characters
                                e.target.value = e.target.value.replace(
                                  /[^A-Za-z\s]/g,
                                  ""
                                ); // Removes non-alphabet characters
                              }}
                            />
                          ) : (
                            department.departmentName
                          )}
                        </TableCell>
                        <TableCell>
                          {department?.departmentID || ""}
                        </TableCell>
                        <TableCell>
                          {department?.departmentType || ""}
                        </TableCell>
                        {/* <TableCell>
      {department.roles?.length > 0 ? (
        department.roles.map((role, roleIndex) => (
          <Typography key={roleIndex}>
            • {role.roleName} ({role.teamMembers})
          </Typography>
        ))
      ) : (
        'NA'
      )}
    </TableCell> */}
                        <TableCell>
                          {department.rolesList?.length > 0
                            ? department.rolesList.map((role, roleIndex) => (
                                <Typography key={roleIndex}>
                                  {role.role_name} ({role.userCount})
                                </Typography>
                              ))
                            : ""}
                        </TableCell>
                        <TableCell>
                          {department.departmentType === "New" &&
                            department.isNew === false && (
                              // department.isNew
                              <IconButton
                                //onClick={() => handleDeleteRow(department.departmentID,department.tempID)}
                                //onClick={handleDeleteRow}
                                onClick={() =>
                                  handleDeleteRow(
                                    department,
                                    department.departmentID,
                                    department.tempID
                                  )
                                }
                              >
                                <DeleteOutlinedIcon style={{ color: "red" }} />
                              </IconButton>
                            )}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <Button
            variant="contained"
            color="primary"
            endIcon={<ChevronRight />}
            //disabled={!hasChanges}
            disabled={handleDisableSave()}
            style={{
              display: "flex",
              justifyContent: "center",
              borderRadius: "20px",
              textTransform: "none",
            }}
            onClick={handleSaveChanges}
          >
            Save changes
          </Button>
        </DialogActions>

        <Dialog open={openSuccessDialog} maxWidth="sm" fullWidth>
          <DialogContent className={classes.dialogContent}>
            <CheckCircleIcon className={classes.avatar} />

            <Typography variant="h6" style={{ marginTop: "10px" }}>
              Department list updated
            </Typography>
            <Typography variant="body1" style={{ marginTop: "10px" }}>
              The list of departments has been updated successfully
            </Typography>

            <DialogActions className={classes.dialogActions}>
              <Button
                variant="contained"
                color="primary"
                endIcon={<ChevronRight />}
                style={{
                  borderRadius: "20px",
                  textTransform: "none",
                }}
                onClick={handleClose}
              >
                Ok
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
        {departmentDetailsList
          .filter((department) => !department.markForDelete)
          .map((department, index) => (
            <Backdrop className={classes.backdrop} open={showDrawer}>
              <Slide
                direction="left"
                in={showDrawer}
                mountOnEnter
                unmountOnExit
              >
                <Box
                  width={410}
                  sx={{
                    // width: "20rem",
                    height: "100%",
                    position: "fixed",
                    right: 0,
                    top: 0,
                    backgroundColor: "#fff",
                    padding: "16px",
                    boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                    zIndex: 1300,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Typography variant="h6" fontWeight="bold" mb={2}>
                      Delete department
                    </Typography>
                    <hr className={classes.hr} />
                    <Typography variant="body1" gutterBottom>
                      <b>Warning:</b>
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{
                        border: "2px solid red", // Red border
                        borderRadius: "4px",
                        padding: "8px",
                        fontWeight: "bold",
                        color: "red", // Red text
                        lineHeight: 1.5,
                      }}
                    >
                      You are deleting the department:{" "}
                      <b>{selectedDepartment?.departmentName}</b>. Team members
                      may lose access to certain areas of the application. This
                      action cannot be reversed. Please assign alternate roles
                      for affected team members.
                    </Typography>
                  </Box>

                  <Box
                    display="flex"
                    justifyContent="space-between"
                    style={{ paddingBottom: "3rem" }}
                    mt={4}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => setShowDrawer(false)}
                      style={{
                        textTransform: "none",
                        borderRadius: "8px",
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      //onClick={() => handleProceedDelete(department.departmentID,department.tempID)}
                      onClick={() =>
                        handleProceedDelete(
                          selectedDepartment.departmentID,
                          selectedDepartment.tempID
                        )
                      }
                      // onClick={() => handleProceedDelete(department)}
                      // onClick={handleProceedDelete}
                      style={{
                        textTransform: "none",
                        borderRadius: "8px",
                        backgroundColor: "#1976D2",
                      }}
                    >
                      Proceed
                    </Button>
                  </Box>
                </Box>
              </Slide>
            </Backdrop>
          ))}
      </Dialog>

      {/* <Drawer anchor="right" open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <Box width={400} p={3}>
          <Typography variant="h6">Assign Alternate Roles</Typography>
          {departmentDetailsList?.rolesList.map((role, index) => (
            <Box key={index} p={2} border={1} borderRadius={8} mb={2}>
              <Typography variant="subtitle1">{role.role_name}</Typography>
              {role.userDetails.map((user) => (
                <Box key={user.saas_user_id} p={1}>
                  <Typography>{user.Name}</Typography>
                  <Typography variant="body2">{user.email_address}</Typography>

                  <FormControl fullWidth style={{ marginTop: 10 }}>
                    <InputLabel>Select Department</InputLabel>
                    <Select>
                      {departmentDetailsList?.map((dept) => (
                        <MenuItem key={dept.departmentID} value={dept.departmentID}>
                          {dept.departmentName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth style={{ marginTop: 10 }}>
                    <InputLabel>Select Role</InputLabel>
                    <Select>
                      <MenuItem value="Manager">Manager</MenuItem>
                      <MenuItem value="Supervisor">Supervisor</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              ))}
            </Box>
          ))}

          <Button variant="contained" color="secondary" onClick={() => setOpenDrawer(false)}>
            Close
          </Button>
        </Box>
      </Drawer> */}

      {/* <Drawer anchor="right" open={openDrawer} onClose={() => setOpenDrawer(false)}>
  <Box width={400} p={3}>
    <Typography variant="h6">Assign Alternate Roles</Typography>
    {selectedDepartment?.rolesList.map((role, index) => (
      <Box key={index} p={2} border={1} borderRadius={8} mb={2}>
        <Typography variant="subtitle1">{role.role_name}</Typography>
        {role.userDetails.map((user) => (
          <Box key={user.saas_user_id} p={1}>
            <Typography>{user.Name}</Typography>
            <Typography variant="body2">{user.email_address}</Typography>

            <FormControl fullWidth style={{ marginTop: 10 }}>
              <InputLabel>Select Department</InputLabel>
              <Select>

                <MenuItem key={selectedDepartment.departmentID} value={selectedDepartment.departmentID}>
                  {selectedDepartment.departmentName}
                </MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth style={{ marginTop: 10 }}>
              <InputLabel>Select Role</InputLabel>
              <Select>
            
                <MenuItem value="Manager">Manager</MenuItem>
                <MenuItem value="Supervisor">Supervisor</MenuItem>
              </Select>
            </FormControl>
          </Box>
        ))}
      </Box>
    ))}

    <Button variant="contained" color="secondary" onClick={() => setOpenDrawer(false)}>
      Close
    </Button>
  </Box>
</Drawer> */}

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        <Box
          width={410}
          p={3}
          display="flex"
          flexDirection="column"
          height="100%"
        >
          <Typography variant="h6" style={{ fontWeight: 550 }}>
            Delete role
          </Typography>
          <hr
            width={410}
            style={{
              backgroundColor: "grey",
              // width: "1rem",
              height: "1px",
              margin: "inherit",
              marginBottom: "1rem",
              marginTop: "1rem",
            }}
          />
          <Typography
            variant="h6"
            style={{ fontWeight: 600, marginBottom: "2rem" }}
          >
            Assign Alternate role(s)
          </Typography>

          {selectedDepartment && (
            <Box mb={2}>
              {/* Displaying the Department Name */}
              {/* <Typography variant="h6">{`${selectedDepartment?.departmentName}`}</Typography> */}

              {/* Mapping rolesList inside selectedDepartment */}
              {selectedDepartment?.rolesList?.map((role, index) => (
                <Box key={index} p={1} mb={2}>
                  {/* Displaying Role Name with Department */}
                  <Typography
                    style={{ fontWeight: 550, fontSize: "1rem" }}
                    variant="h6"
                  >{`${selectedDepartment?.departmentName} - ${role?.role_name}`}</Typography>

                  <Typography
                    style={{ fontSize: "1rem", marginBottom: "0.5rem" }}
                    variant="subtitle1"
                  >
                    ({role.userCount} team Members)
                  </Typography>

                  {/* Mapping Users for each Role */}
                  {role?.userDetails?.map((user, userIndex) => {
                    const isDepartmentSelected =
                      !!userDepartmentRole[user.saas_user_id]
                        ?.selectedDepartmentID;
                    const isRoleSelected =
                      !!userDepartmentRole[user.saas_user_id]?.selectedRole;

                    return (
                      <Box
                        key={user.saas_user_id}
                        style={{
                          backgroundColor:
                            (isDepartmentSelected && isRoleSelected) ||
                            autofillChecked
                              ? "#f3faee"
                              : "#ffe6e6",

                          marginBottom: "0.5rem",
                          marginRight: "1rem",
                          paddingLeft: "1rem",
                          paddingTop: "1rem",
                          paddingBottom: "1rem",
                          paddingRight: "1rem",
                          borderRadius: "0.2rem",
                        }}
                        width="90%"
                      >
                        <Grid
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                          }}
                        >
                          <Grid>
                            <UserAvatar profileImage={user?.profile_pic} />
                          </Grid>
                          <Grid
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                            }}
                          >
                            <Typography
                              style={{ fontWeight: "bold", fontSize: "0.8rem" }}
                            >
                              {user.name}
                            </Typography>
                            <Typography
                              style={{ fontSize: "0.8rem" }}
                              variant="body2"
                              color="textSecondary"
                            >
                              {user.email_address}
                            </Typography>
                          </Grid>
                        </Grid>

                        {/* Department Dropdown */}

                        <FormControl fullWidth style={{ marginTop: 10 }}>
                          <Typography
                            variant="body1"
                            style={{ marginBottom: 5, fontWeight: 550 }}
                          >
                            Select Department{" "}
                            <span style={{ color: "red", fontWeight: "bold" }}>
                              {" "}
                              *
                            </span>
                          </Typography>
                          <TextField
                            size="small"
                            select
                            variant="outlined"
                            placeholder="Search and select from the list"
                            fullWidth
                            value={
                              autofillChecked &&
                              user.saas_user_id !== getFirstUserId()
                                ? userDepartmentRole[getFirstUserId()]
                                    ?.selectedDepartmentID
                                : userDepartmentRole[user.saas_user_id]
                                    ?.selectedDepartmentID || ""
                            }
                            onChange={(e) =>
                              handleDepartmentChange(
                                user.saas_user_id,
                                e.target.value
                              )
                            }
                            disabled={
                              autofillChecked &&
                              user.saas_user_id !== getFirstUserId()
                            }
                          >
                            {fetchDepartmentsList?.departmentDetailsList
                              ?.filter(
                                (department) =>
                                  department.departmentName !==
                                  selectedDepartment?.departmentName
                              )
                              ?.map((department) => (
                                <MenuItem
                                  key={department.departmentID}
                                  value={department.departmentID}
                                >
                                  {department.departmentName}
                                </MenuItem>
                              ))}
                          </TextField>
                        </FormControl>

                        {/* Role Dropdown */}

                        <FormControl fullWidth style={{ marginTop: 10 }}>
                          <Typography
                            variant="body1"
                            style={{ marginBottom: 5, fontWeight: 550 }}
                          >
                            Select Role{" "}
                            <span style={{ color: "red", fontWeight: "bold" }}>
                              {" "}
                              *
                            </span>
                          </Typography>
                          <TextField
                            select
                            variant="outlined"
                            size="small"
                            fullWidth
                            placeholder="select from the list"
                            value={
                              autofillChecked &&
                              user.saas_user_id !== getFirstUserId()
                                ? userDepartmentRole[getFirstUserId()]
                                    ?.selectedRole
                                : userDepartmentRole[user.saas_user_id]
                                    ?.selectedRole || ""
                            }
                            onChange={(e) =>
                              handleRoleChange(
                                user.saas_user_id,
                                e.target.value
                              )
                            }
                            disabled={
                              autofillChecked &&
                              user.saas_user_id !== getFirstUserId()
                            }
                          >
                            {/* Use first user's markedDepartment if autofill is ON */}
                            {(autofillChecked
                              ? userDepartmentRole[getFirstUserId()]
                                  ?.markedDepartment?.rolesList
                              : userDepartmentRole[user.saas_user_id]
                                  ?.markedDepartment?.rolesList
                            )?.map((role) => (
                              <MenuItem
                                key={role.role_name}
                                value={role.role_name}
                              >
                                {role.role_name}
                              </MenuItem>
                            ))}
                          </TextField>
                        </FormControl>

                        {/* Checkbox to Autofill Users */}
                        {/* {user.saas_user_id === firstUserId && ( */}
                        {userIndex === 0 && index === 0 && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={autofillChecked}
                                onChange={handleAutofillChange}
                                disabled={
                                  !isDepartmentSelected || !isRoleSelected
                                }
                              />
                            }
                            label="Assign same alternate department-role to remaining team members"
                            // onClick={applyAutofill}
                          />
                        )}
                        {/* )} */}
                      </Box>
                    );
                  })}
                </Box>
              ))}
            </Box>
          )}

          {/* Add More Boxes based on Count of Users */}
          {/* {selectedDepartment?.rolesList.map((role, index) => (
      <Box key={index} p={2} border={1} borderRadius={8} mb={2}>
        <Typography variant="subtitle1">{role.role_name} ({role.countOfUsers} Users)</Typography>
        {[...Array(role.countOfUsers)].map((_, userIndex) => (
          <Box key={userIndex} p={1}>
            <FormControl fullWidth style={{ marginTop: 10 }}>
              <InputLabel>Select Department</InputLabel>
              <Select>
                {fetchDepartmentsList?.data?.map((department) => (
                  <MenuItem key={department.departmentID} value={department.departmentID}>
                    {department.departmentName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth style={{ marginTop: 10 }}>
              <InputLabel>Select Role</InputLabel>
              <Select>
                {fetchDepartmentsList?.data?.map((department) => 
                  department.rolesList.map((roleItem) => (
                    <MenuItem key={roleItem.role_name} value={roleItem.role_name}>
                      {roleItem.role_name}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Box>
        ))}
      </Box>
    ))} */}
          <Box
            display="flex"
            justifyContent="space-between"
            mt="auto"
            style={{ marginBottom: "2rem" }}
          >
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setOpenDrawer(false)}
              style={{
                backgroundColor: "rgba(217, 217, 221, 0.8)",
                color: "black",
              }}
            >
              Back
            </Button>
            <Button
              variant="contained"
              style={{
                backgroundColor: "#286acf",
                color: "#fff",
              }}
              onClick={() => handleUpdate("confirm")}
            >
              confirm Changes
            </Button>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default EditDepartmentScreen;
